import { appPaths } from "../../../shared/routing/appPaths";
import type { GraphNode } from "../model/workflowGraph";

/**
 * The page a node's title opens, for viewing (F51): the step, sub-workflow, artifact or
 * selected item at the version the Workflow pins; `null` if none. Changing it is the card's
 * Edit, which opens the edit Thread (`editTarget`), never this address.
 */
export function nodeAddress(node: GraphNode): string | null {
  switch (node.kind) {
    case "step":
      return appPaths.item(node.reference);
    case "sub_workflow":
      return node.workflow === null ? null : appPaths.workflow(node.reference);
    case "abstract_step":
      return null;
    case "artifact":
      return appPaths.item(node.artifact.reference);
    case "selection":
      return node.item === null ? null : appPaths.item(node.item.reference);
    case "terms":
      return appPaths.ontology();
    case "item":
      return appPaths.item(node.item.reference);
  }
}
